export default __webpack_public_path__ + "static/media/p2023-45.871e3c1c.jpeg";